import gql from 'graphql-tag'

export default gql`
  mutation RequestCreditCardUpdate($viewerId: ID!, $returnUrl: String!) {
    requestCreditCardUpdate(viewerId: $viewerId, returnUrl: $returnUrl)
  }
`
